module.exports = __webpack_public_path__ + "img/report-sample-17@3x.7e0ac47f.png";